/** Mapbox image id prefix; each low-zoom selected mark appends its zone type. */
export const SELECTED_ZONE_HEX_ICON = 'selected-zone-hex';
/** Logical pixels. Matches the old 12px-radius bubble, and the zones pictogram's size. */
export const SELECTED_ZONE_HEX_SIZE = 24;

/** Lucide's hexagon, the path the zones filter draws. */
const HEX_PATH =
  'M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z';

/**
 * One hexagon, filled and outlined in white, the same mark as the zones pictogram.
 * A single zone rather than the pictogram's three-type stack.
 */
export function zoneHexagonSvg(fill: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="${SELECTED_ZONE_HEX_SIZE}" height="${SELECTED_ZONE_HEX_SIZE}" viewBox="0 0 24 24" fill="none"><path d="${HEX_PATH}" fill="${fill}" stroke="#FFFFFF" stroke-width="2" stroke-linejoin="round"/></svg>`;
}
